<!-- 商品管理 V2 - 批量提交审核确认弹框 -->
<template>
  <el-dialog
    :title="$t('message.productV2SubmitAuditPrompt')"
    :visible.sync="visible"
    width="560px"
    append-to-body
    custom-class="submit-audit-dialog"
  >
    <div class="audit-dialog-content">
      <p class="audit-warning">{{ $t('message.productV2SubmitAuditWarning') }}</p>
      <div class="audit-groups">
        <div v-for="group in groups" :key="group.user_id" class="audit-customer-group">
          <p>{{ $t('message.clientID') }}：{{ group.user_id }}</p>
          <p v-for="code in group.client_sku_codes" :key="code">{{ code }}</p>
        </div>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="visible = false">{{ $t('message.cancel') }}</el-button>
      <el-button type="primary" @click="submit">{{ $t('message.submit') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'SubmitAuditDialog',
  data() {
    return { visible: false, loading: false, list: [] }
  },
  computed: {
    groups() {
      const groups = {}
      this.list.forEach(item => {
        if (!groups[item.user_id]) groups[item.user_id] = { user_id: item.user_id, client_sku_codes: [] }
        groups[item.user_id].client_sku_codes.push(item.client_sku_code)
      })
      return Object.values(groups)
    }
  },
  methods: {
    open(list) {
      this.list = list.slice()
      this.visible = true
    },
    async submit() {
      this.loading = true
      try {
        const res = await this.$api.productManagementApi.submitAudit({
          sys_code_set: this.list.map(item => item.sys_code)
        })
        this.$message.success(res.msg)
        this.visible = false
        this.$emit('success')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss">
.submit-audit-dialog {
  .el-dialog__body { padding: 24px 28px 8px; }
  .audit-dialog-content { padding: 0 4px; }
  .audit-warning { margin: 0 0 12px; color: #333; line-height: 20px; }
  .audit-groups { display: flex; flex-wrap: wrap; gap: 20px; }
  .audit-customer-group { min-width: 110px; }
  .audit-customer-group p { margin: 0; line-height: 20px; word-break: break-all; }
}
</style>
